import React, { forwardRef, HTMLProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface InputProps extends HTMLProps<HTMLInputElement> {}

export const Input = forwardRef(
  (
    { className, ...rest }: InputProps,
    ref: React.LegacyRef<HTMLInputElement>,
  ) => {
    const _className = twMerge(
      'max-w-full p-3 bg-white border border-secondary outline-none rounded focus:border-primary',
      className,
    )

    return <input ref={ref} className={_className} {...rest} />
  },
)
